/*
 * @Description:
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-01-16 10:04:12
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbMember {
    /**
     * 会员列表
     */
    export var GetTbMemberList = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetTbMemberList`, body);
    };
    /**
     * 新增会员
     */
    export var PostTbMember = (body: any): Promise<any> => {
        return Post(`/api/TbMember/PostTbMember`, body);
    };
    /**
     * 查询会员信息
     */
    export var GetTbMemberById = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetTbMemberById`, body);
    };
    /**
     * 修改会员信息
     */
    export var PutTbMember = (body: any): Promise<any> => {
        return Put(`/api/TbMember/PutTbMember`, body);
    };
    /**
     * 删除会员
     */
    export var DeleteMemberList = (body: any): Promise<any> => {
        return Post(`/api/TbMember/DeleteMemberList`, body);
    };
    /**
     * 获取余额交易明细
     */
    export var GetBalanceList = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetBalanceList`, body);
    };
    /**
     * 获取余额交易明细合计
     */
    export var GetBalanceTotal = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetBalanceTotal`, body);
    };
    /**
     * 新增余额调整
     */
    export var AddBalanceAdjustment = (body: any): Promise<any> => {
        return Post(`/api/TbMember/AddBalanceAdjustment`, body);
    };
    /**
     * 新增积分调整
     */
    export var AddMemberScore = (body: any): Promise<any> => {
        return Post(`/api/TbMember/AddMemberScore`, body);
    };
    /**
     * 新增会员交易明细-充值
     */
    export var PostAddMemberTradeDetail = (body: any): Promise<any> => {
        return Post(`/api/TbMember/PostAddMemberTradeDetail`, body);
    };
    /**
     * 充值订单支付
     */
    export var PostMemberTradePayV2 = (body: any): Promise<any> => {
        return Post(`/api/TbMember/PostMemberTradePayV2`, body);
    };
    /**充值订单支付V3（去轮询版，第三方支付等待状态由前端轮询）*/
    export var PostMemberTradePayV3 = (body: any): Promise<any> => {
        return Post(`/api/TbMember/PostMemberTradePayV3`, body);
    };
    /**充值订单支付状态查询（前端轮询用）*/
    export var GetMemberTradePayStatus = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetMemberTradePayStatus`, body);
    };
    /**
     * 新增会员交易明细-充值V3
     */
    export var PostAddMemberTradeDetailV3 = (body: any): Promise<any> => {
        return Post(`/api/TbMember/PostAddMemberTradeDetailV3`, body);
    };
    /**
     * 会员充值异常列表
     */
    export var GetMemberRechargeExceptionList = (body: any): Promise<any> => {
        return Get(`/api/TbMember/GetMemberRechargeExceptionList`, body);
    };




}



// WEBPACK FOOTER //
// ./src/http/api_TbMember.ts